import DefaultBoardSelector from './DefaultBoardSelector';

export default DefaultBoardSelector;
